import useDispatch from 'hooks/useDispatch'
import { useEffect } from 'react'
import { replace } from 'react-router-redux'
import { history } from 'store'

export default function useLegalDocsBlock(
  isBlocked: boolean,
  redirectTo: string,
  onBlockedNavigation?: () => void
) {
  const dispatch = useDispatch()
  const allowPath = redirectTo.split('#')[0]

  useEffect(() => {
    if (!isBlocked) return

    if (!history.location.pathname.startsWith(allowPath)) {
      dispatch(replace(redirectTo))
    }

    const unblock = history.block(location => {
      if (location.pathname.startsWith(allowPath)) {
        return undefined as any
      }
      onBlockedNavigation?.()
      return false as any
    })

    return () => {
      unblock()
    }
  }, [isBlocked, dispatch, onBlockedNavigation, redirectTo, allowPath])
}
